export { default as getIndexRouteWildcard } from './getIndexRouteWildcard';
export { default as onEnterWildcard } from './onEnterWildcard';
export { default as onEnterSearhPage } from './onEnterSearchPage';
export { default as getIndexRouteSearchPage } from './getIndexRouteSearchPage';
export { default as getIndexRouteLang } from './getIndexRouteLang';
export { default as getChildRoutesLang } from './getChildRoutesLang';
export { default as getCityCountry } from './getCityCountry';
export { default as onEnterMy } from './onEnterMy';
export { default as onEnterLangIndex } from './onEnterLangIndex';
export { default as onEnterDefault } from './onEnterDefault';
export { default as onEnterPayoutMethods } from './onEnterPayoutMethods';
export {
  default as redirectedRoutes,
  onEnterUserProfile,
  onEnterRoomPage,
} from './redirectedRoutes';
export { default as getHowItWorks } from './getHowItWorks';
export { default as onEnterListYourPlace } from './onEnterListYourPlace';
export { default as onEnterAuthenticated } from './onEnterAuthenticated';
export { getIndexRouteCountry } from './getIndexRouteCountry';
export { countryPageRoute } from './countryPageRoute';
